<template lang="html">
  <div class="placed-backg" id="gallery-page" data-aos="fade">

    <section class="title-section">
      <h1 class="title-s1">Galería</h1>
      <img src="" alt="">
    </section>

    <section class="container oversized-container gallery-section">
      <!-- <div>
        <b-card-group columns>
          <b-card :img-src="image.imgUrl" v-for="(image, iInx) in gallery" :key="iInx">
            <b-card-text><a class="_btn trans-250" @click="showModal(iInx)"></a></b-card-text>
          </b-card>
        </b-card-group>
      </div> -->

      <div class="">
        <div class="card-columns" v-lazy-container="{ selector: 'img', loading: 'public/images/pages/gallery/loading.gif' }">
          <div class="card" v-for="(image, iInx) in gallery" :key="iInx">
            <img class="card-img" :data-src="image.imgUrl">
            <a class="_btn trans-250" @click="showModal(iInx)"></a>
          </div>
        </div>
      </div>

    </section>

    <b-modal id="modal-gallery" ref="modal-gallery" size="lg" centered hide-footer>
      <img class="img-modal" :src="modal.imgUrl">
    </b-modal>
  </div>
</template>

<script>
export default {
  data(){
    return{
      gallery: [
        { imgUrl: 'public/images/pages/gallery/image-1.jpg' },
        { imgUrl: 'public/images/pages/gallery/image-2.jpg' },
        { imgUrl: 'public/images/pages/gallery/image-3.jpg' },
        { imgUrl: 'public/images/pages/gallery/image-4.jpg' },
        { imgUrl: 'public/images/pages/gallery/image-5.jpg' },
        { imgUrl: 'public/images/pages/gallery/image-6.jpg' },
        { imgUrl: 'public/images/pages/gallery/image-7.jpg' },
        { imgUrl: 'public/images/pages/gallery/image-8.jpg' },
        { imgUrl: 'public/images/pages/gallery/image-9.jpg' },
        { imgUrl: 'public/images/pages/gallery/image-10.jpg' },
        { imgUrl: 'public/images/pages/gallery/image-11.jpg' },
      ],

      modal: {
        imgUrl: null
      }
    }
  },

  methods: {
    showModal(inx){
      this.modal = this.gallery[inx];
      this.$refs['modal-gallery'].show();
    }
  },

  mounted(){},
}
</script>
